import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { Card, CardContent, Typography, Button } from '@material-ui/core';
import MyDialog from '../Common/MyDialog';
import { startAccountLink } from './asLinkFlow';
import './LinkAccount.css';

/**
 * Tarjeta del inicio cuando el socio ya tiene cuenta nueva: muestra el email enmascarado y
 * "No soy yo, cambiar cuenta", que avisa antes de reemplazar el vínculo.
 */
class AsLinkCard extends Component {
    state = { confirming: false, starting: false };

    change = async () => {
        this.setState({ confirming: false, starting: true });
        const result = await startAccountLink();
        if (!result.ok) {
            this.setState({ starting: false });
        }
    };

    render() {
        const { t, asLink } = this.props;
        if (!asLink || asLink.status !== 'linked') {
            return null;
        }
        const { confirming, starting } = this.state;
        return (
            <Card className="asLinkInline">
                <CardContent>
                    <Typography variant="subtitle2">{t('as_link_card_title')}</Typography>
                    <Typography variant="body2">{asLink.masked_email}</Typography>
                    <Button size="small" color="primary" onClick={() => this.setState({ confirming: true })} disabled={starting}>
                        {starting ? t('as_link_starting') : t('as_link_card_change')}
                    </Button>
                </CardContent>
                <MyDialog
                    showModal={confirming}
                    title={t('as_link_card_change_title')}
                    message={t('as_link_card_change_message', { email: asLink.masked_email })}
                    handleClose={() => this.setState({ confirming: false })}
                    handleAgree={this.change}
                    noLabel="No"
                    yesLabel="as_link_card_change_confirm"
                />
            </Card>
        );
    }
}

export default withNamespaces()(AsLinkCard);
